import React from 'react';
import moment from 'moment';

import './play-search-more-link.scss';

const LOCALE = 'de-CH';

export const PlaySearchMoreLink = ({
  counter = {},
  translations,
  playLink,
  audioLink,
  dateFilter,
  dateKey,
  searchQuery,
}) => {
  const dateFilterString =
    dateFilter === 'all'
      ? ''
      : `&from=${dateFilter}&to=${moment().format('YYYY-MM-DD')}`;
  return (
    <li className="collection-ng__teaser-item js-teaser-ng-item play-search-more-link">
      {counter.video > 1 && (
        <a
          className="teaser-ng js-teaser-ng play-search-more-link__fake-teaser"
          href={`${playLink}?query=${searchQuery}${dateFilterString}&mediaType=video`}
          data-referrer-track="srg_override_mod1=play_srf&srg_override_mod2=link&srg_override_mod3=Alle Resultate Video anzeigen&srg_override_mod4=">
          <span className="teaser-ng__title">
            <span className="svg-icon svg-icon--play-video-circle-white svg-icon--tiny-but-small-on-tablet-up"></span>{' '}
            {translations.moreVideoResults.replace(
              '%resultCount%',
              Number(counter.video).toLocaleString(LOCALE),
            )}
          </span>
        </a>
      )}
      {counter.audio > 1 && (
        <a
          className="teaser-ng js-teaser-ng play-search-more-link__fake-teaser"
          href={`${audioLink}?q=${searchQuery}&date=${dateKey}`}
          data-referrer-track="srg_override_mod1=play_srf&srg_override_mod2=link&srg_override_mod3=Alle Resultate Audio anzeigen&srg_override_mod4=">
          <span className="teaser-ng__title">
            <span className="svg-icon svg-icon--play-audio-white svg-icon--tiny svg-icon--tiny-but-small-on-tablet-up"></span>{' '}
            {translations.moreAudioResults.replace(
              '%resultCount%',
              Number(counter.audio).toLocaleString(LOCALE),
            )}
          </span>
        </a>
      )}
    </li>
  );
};

export default PlaySearchMoreLink;
